export const elRelojDeLaEstacionAbandonada = `En las afueras de la ciudad había una antigua estación de tren que ya no se utilizaba. Los edificios estaban cubiertos de polvo y las vías oxidadas, pero un objeto seguía funcionando: un gran reloj colocado sobre la entrada principal.

Cada día marcaba la hora con precisión, aunque no hubiera trenes ni pasajeros. Nadie sabía quién le daba mantenimiento.

Un joven llamado Arturo pasaba por ahí todas las mañanas camino a su trabajo. Siempre miraba el reloj para comprobar si iba a tiempo. Un día decidió investigar y encontró a una mujer mayor dentro de la estación limpiando el mecanismo.

Ella le explicó que su padre había sido jefe de estación durante muchos años y que, aunque ya no existían trenes, mantener el reloj funcionando era su manera de honrar su memoria.

—El tiempo no se detiene solo porque un lugar quede vacío —dijo ella—. Mientras el reloj siga avanzando, este lugar seguirá vivo de alguna forma.

Desde entonces, Arturo ya no veía el reloj como algo extraño, sino como un símbolo de constancia.`


export const preguntasElRelojDeLaEstacionAbandonada = [
	{
		id: "pregunta1",
		pregunta: "¿Dónde estaba ubicada la estación de tren?",
		opciones: ["En el centro de la ciudad", "En las afueras de la ciudad", "En la playa", "En una montaña"],
		respuesta: "En las afueras de la ciudad",
	},
	{
		id: "pregunta2",
		pregunta: "¿Qué objeto seguía funcionando en la estación abandonada?",
		opciones: ["Una locomotora", "Un reloj grande", "Las luces", "Una puerta automática"],
		respuesta: "Un reloj grande",
	},
	{
		id: "pregunta3",
		pregunta: "¿Quién era Arturo?",
		opciones: ["Un trabajador que pasaba por ahí", "El dueño de la estación", "Un mecánico", "Un turista"],
		respuesta: "Un trabajador que pasaba por ahí",
	},
	{
		id: "pregunta4",
		pregunta: "¿Por qué la mujer mantenía el reloj funcionando?",
		opciones: [
			"Para ganar dinero",
			"Porque era su trabajo",
			"Para honrar la memoria de su padre",
			"Porque no sabía apagarlo"
		],
		respuesta: "Para honrar la memoria de su padre",
	},
	{
		id: "pregunta5",
		pregunta: "¿Qué simbolizaba el reloj para Arturo al final?",
		opciones: ["El abandono", "La constancia", "La tristeza", "El peligro"],
		respuesta: "La constancia",
	},
];
